import { render, staticRenderFns } from "./EmployeeWidget.vue?vue&type=template&id=4c6e1178&"
import script from "./EmployeeWidget.vue?vue&type=script&lang=js&"
export * from "./EmployeeWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports